<template>
    <div style="margin-top:30px">
        <el-form ref="form" :rules="rules" :model="form" label-width="100px">
                            <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="" prop="code" style="margin-right:15px">
                                <el-input v-model="form.code" placeholder="请输入" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="用户编码code" prop="userCode" style="margin-right:15px">
                                <el-input v-model="form.userCode" placeholder="请输入用户编码code" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="组织机构编码" prop="branchCode" style="margin-right:15px">
                                <el-input v-model="form.branchCode" placeholder="请输入组织机构编码" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="姓名" prop="boardName" style="margin-right:15px">
                                <el-input v-model="form.boardName" placeholder="请输入姓名" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="电话" prop="boardPhone" style="margin-right:15px">
                                <el-input v-model="form.boardPhone" placeholder="请输入电话" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="邮件" prop="boardEmail" style="margin-right:15px">
                                <el-input v-model="form.boardEmail" placeholder="请输入邮件" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="留言内容" prop="boardContent" style="margin-right:15px">
                                <el-input v-model="form.boardContent" placeholder="请输入留言内容" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="公司" prop="boardCompany" style="margin-right:15px">
                                <el-input v-model="form.boardCompany" placeholder="请输入公司" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="阅读次数" prop="readNumber" style="margin-right:15px">
                                <el-input v-model="form.readNumber" placeholder="请输入阅读次数" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="funcCancel">取 消</el-button>
            <el-button type="primary" @click="funcSubmit">确 定</el-button>
        </div>
    </div>
</template>
<script>
    import request from '@/utils/request'
    export default {
        name: 'messageBoardAdd',
        data() {
            return {
                form: {
                code: '',
                userCode: '',
                branchCode: '',
                boardName: '',
                boardPhone: '',
                boardEmail: '',
                boardContent: '',
                boardCompany: '',
                readNumber: '',
                },
                rules: {
                    code: [
                        { required: true, message: '请输入', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 32 个字符', trigger: 'blur' }
                    ],
                    userCode: [
                        { required: true, message: '请输入用户编码code', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 32 个字符', trigger: 'blur' }
                    ],
                    branchCode: [
                        { required: true, message: '请输入组织机构编码', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 32 个字符', trigger: 'blur' }
                    ],
                    boardName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    boardPhone: [
                        { required: true, message: '请输入电话', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    boardEmail: [
                        { required: true, message: '请输入邮件', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
                    ],
                    boardContent: [
                        { required: true, message: '请输入留言内容', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 500 个字符', trigger: 'blur' }
                    ],
                    boardCompany: [
                        { required: true, message: '请输入公司', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    readNumber: [
                        { required: true, message: '请输入阅读次数', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                    ],
                }
            }
        },
        created() {},
        methods: {
            //提交
            funcSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const data = this.form
                        request({ url: '/ntocc-basic-api/messageBoard', method: 'post', params: data }).then(response => {
                            this.$message({ message: response.msg, type: 'success' })
                            this.$emit('fatherAddMethod')
                        }).then(()=>this.$refs['form'].resetFields())
                    } else {
                        return false
                    }
                })
            },
            //取消
            funcCancel() {
                this.$emit('fatherCancelMethod','add')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
